import { CommerceApiName } from './Api'

export type HostEnvironment = {
  host: string
  brand: string
  country: string
  locale: string /* en-ca, fr-ca */
  langId?: string
  storeId: string
  currency: string
  dateFormat: string /* default 'MM/dd/yyyy' */
  basePath: string
  basePathSearch?: string
  cartPath: string
  signInPath: string
  signInRedirectParam: string
  signInRedirectStripLocale: boolean
  ecommerceCode: string
  ecommerceTransactionHost?: string
  termsConditionsUrl: string
  privacyPolicyUrl: string
  cookiesPolicyUrl: string
  insuranceLandingPageUrl: string
  faqUrl: string
  localEnv?: 'dev' | 'test' | 'stage'
}

export type HostEnvironmentOverride = {
  lang: string
  termsConditionsUrl?: string
  privacyPolicyUrl?: string
  cookiesPolicyUrl?: string
  faqUrl?: string
  insuranceLandingPageUrl?: string
}

export const InitialHostEnvironment = {
  host: '',
  brand: '',
  country: '',
  locale: '',
  storeId: '',
  currency: '',
  dateFormat: 'MM/dd/yyyy',
  basePath: '',
  cartPath: '/en-ca/cart',
  signInPath: '/en-ca/sign-in',
  signInRedirectParam: 'redirectUrl',
  signInRedirectStripLocale: false,
  ecommerceCode: 'N1',
  termsConditionsUrl: '/en-ca/c/terms-and-conditions',
  privacyPolicyUrl: '/en-ca/c/privacy-policy',
  cookiesPolicyUrl: '',
  faqUrl: '',
  insuranceLandingPageUrl: '/en-ca/direct-billing-vision-care-insurance',
}

export type HostSession = {
  sessionId: string
  isLoggedIn: boolean
  isGuest: boolean
  isPartiallyAuthenticated: boolean
  isAnonymous?: boolean
  cartId?: string
  userId?: string
  wcToken?: string
  wcTrustedToken?: string
}
